import GameOptions from "../../../model/options/GameOptions";
import GameOptionsToggle from "./GameOptionsToggle";

export default class DisplayFpsGameOptionsToggle extends GameOptionsToggle {
    /**
     * @param {string} parentId
     * @param {string} elementId 
     * @param {string} title
     * @param {GameOptions} gameOptions
     */
    constructor(parentId, elementId, title, gameOptions) {
        super(parentId, elementId, title, gameOptions);
    }

    /**
     * @abstract
     * @param {boolean} enabled 
     */
    setEnabled(enabled) {
        this.gameOptions.displayFps = enabled;
    }

    /**
     * @abstract
     * @returns {boolean}
     */
    isEnabled() {
        return this.gameOptions.displayFps;
    }

    /**
     * @override
     */
    toggleEnabled() {
        this.gameOptions.displayFps = !this.gameOptions.displayFps;
    }
}